import { render, staticRenderFns } from "./UiSpinner.vue?vue&type=template&id=4b31ecf4&"
import script from "./UiSpinner.vue?vue&type=script&lang=js&"
export * from "./UiSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports